import { Link } from 'react-router-dom';
import IconBadge from './IconBadge';

function ArticleItem({ article }) {
  const identifier = article.slug || article.id;

  return (
    <li className="article-item">
      <Link to={`/articles/${encodeURIComponent(identifier)}`}>
        <IconBadge icon={article.icon} className="article-item__icon" />
        <span className="article-item__content">
          <strong>{article.title}</strong>
          <small>{article.description}</small>
        </span>
      </Link>
    </li>
  );
}

export default ArticleItem;
